module.exports = __webpack_public_path__ + "slick.526d7fdf63614222d376.svg";


//////////////////
// WEBPACK FOOTER
// C:/Users/jerd_/Documents/e-payment-public/e-payment-frontend/src/assets/slick/fonts/slick.svg
// module id = ../../../../../src/assets/slick/fonts/slick.svg
// module chunks = styles